import { render, staticRenderFns } from "./TableTennisArena.vue?vue&type=template&id=ca3327aa&scoped=true"
import script from "./TableTennisArena.vue?vue&type=script&lang=js"
export * from "./TableTennisArena.vue?vue&type=script&lang=js"
import style0 from "./TableTennisArena.vue?vue&type=style&index=0&id=ca3327aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca3327aa",
  null
  
)

export default component.exports